import React from 'react';
import EmailActionHandler from './EmailActionHandler';
import { 
  Box, 
  Typography, 
  Container,
  useTheme,
  Grow
} from '@mui/material';
import RestoreIcon from '@mui/icons-material/Restore';

const EmailRecovery = () => {
  const theme = useTheme();

  return (
    <Container maxWidth="sm">
      <Grow in={true} timeout={800}>
        <Box 
          sx={{ 
            mt: 4, 
            mb: 2, 
            textAlign: 'center' 
          }}
        >
          <RestoreIcon 
            color="primary" 
            sx={{ 
              fontSize: 80, 
              mb: 2,
              animation: 'float 3s ease-in-out infinite'
            }} 
          />
          <Typography 
            variant="h3" 
            component="h1" 
            gutterBottom
            sx={{ 
              fontWeight: 700,
              background: `linear-gradient(45deg, ${theme.palette.primary.main}, ${theme.palette.primary.light})`,
              backgroundClip: 'text',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              mb: 2
            }}
          >
            Email Recovery
          </Typography>
          <Typography 
            variant="body1" 
            color="text.secondary"
            sx={{ 
              maxWidth: 500, 
              mx: 'auto', 
              mb: 4,
              fontSize: '1.1rem'
            }}
          >
            We're restoring your previous email address. This process helps ensure that your account remains secure and accessible only to you.
          </Typography>
        </Box>
      </Grow>
      
      <EmailActionHandler />
      
      <style jsx global>{`
        @keyframes float {
          0% {
            transform: translateY(0px);
          }
          50% {
            transform: translateY(-10px);
          }
          100% {
            transform: translateY(0px);
          }
        }
      `}</style>
    </Container>
  );
};

export default EmailRecovery; 